export const getTeamSpaceName = (teamId: string) => `team/${teamId}`
export const getRepoSpaceName = (teamId: string, repoId: string) =>
  `team/${teamId}/repo/${repoId}`

export const parseSpaceName = (
  spaceName: string
):
  | { spaceType: 'team'; teamId: string }
  | { spaceType: 'repo'; teamId: string; repoId: string } => {
  const splitted = spaceName.split('/')
  const spaceType = splitted.length === 2 ? 'team' : 'repo'
  if (spaceType === 'repo') {
    return {
      spaceType,
      teamId: splitted[1] as string,
      repoId: splitted[3] as string,
    }
  }
  return { spaceType, teamId: splitted[1] as string }
}

export type AtLeast<T, K extends keyof T> = Partial<T> & Pick<T, K>

export function deepEqual(obj1: unknown, obj2: unknown): boolean {
  // Base case: If both objects are identical, return true.
  if (obj1 === obj2) {
    return true
  }
  // Check if both objects are objects and not null.
  if (
    typeof obj1 !== 'object' ||
    typeof obj2 !== 'object' ||
    obj1 === null ||
    obj2 === null
  ) {
    return false
  }
  // Get the keys of both objects.
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)
  // Check if the number of keys is the same.
  if (keys1.length !== keys2.length) {
    return false
  }
  // Iterate through the keys and compare their values recursively.
  for (const key of keys1) {
    if (
      !keys2.includes(key) ||
      !deepEqual(obj1[key as keyof typeof obj1], obj2[key as keyof typeof obj1])
    ) {
      return false
    }
  }
  // If all checks pass, the objects are deep equal.
  return true
}
